import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './HeaderToggle.scss';

const HeaderToggle = ({ isActive, handleToggle }) => (
  <button
    type='button'
    onClick={handleToggle}
    className='HeaderToggle__wrapper'
    aria-expanded={isActive}
    aria-label='Menu'
  >
    <i
      className={classNames('HeaderToggle', {
        'HeaderToggle--active': isActive,
      })}
    />
  </button>
);

HeaderToggle.propTypes = {
  handleToggle: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default HeaderToggle;
